<template>
  <div class="row">
    <div class="col-xs-4" style="position: sticky; top: 100px; z-index: 1;">
      <h2 class="m-b-20 section-title">{{ $t('Additional services') }}</h2>
<!--      <div class="pickup-toggle-box">-->
<!--        <span class="d-inline-block m-r-10">{{ $t('delivery_to_drop_point') }}</span>-->
<!--        <Toggle id="pickupPointDelivery" v-model="isDroppoint" :key="`update-${update}`"/>-->
<!--      </div>-->
      <div>
        <ToggleList
          :shippingDate="shippingDate"
          :list="servicesList"
          :servicesAllowed="servicesCompiledList"
          :selectedServices="selectedServices"
          :additionalFieldData="additionalFieldData"
          @servicesUpdate="servicesUpdate"
          @extraFieldAdd="extraFieldAdd" />
      </div>
    </div>
    <div class="col-xs-8">
      <h2 class="m-b-20 section-title">{{ $t('LBL_WHEN_DO_YOU_SHIP_THE_SHIPMENT') }}</h2>
      <!-- Filter options -->
      <div class="row m-b-20">
        <div class="col-xs-2" v-for="date in getFirstFiveAvailableShippingDates" :key="date.toFormat('yyyy-MM-dd') ">
          <div class="ship-date-block button-bar shadowed" :class="shippingDate === date.toFormat('yyyy-MM-dd') ? 'active brand' : ''" @click="setShippingDate(date)">
            <div class="ship-date-block-month">{{ $t(date.toFormat('MMMM')) }}</div>
            <div class="ship-date-block-date">{{ date.toFormat('dd') }}</div>
            <div class="ship-date-block-addition">{{ getDayLabel(date) }}</div>
          </div>
        </div>
        <div class="col-xs-2">
          <button-calendar :active="isCustomShippingDate" @date-changed="setShippingDate" />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 m-b-10">
          <text-select :label="`${$t('sort_by')}:`" :options="[{value: 'cheapest', text :  $t('Cheapest')}, {value: 'fastest', text :  $t('Fastest')}]" v-model="activeFilter" />
        </div>
      </div>
      <!-- Skeleton blanko -->
      <div v-if="productsList == null || (productsList.length == 0 && reloadingProducts)">
        <div class="toggle-card-box card p-40 relative"
          v-for="index in 3"
          :key="`productSkeletonEmty-${index}`">
          <div class="card-skeleton-layout">
            <Skeleton
              height="55px"
              width="62px"
              class="m-r-20"
            />
            <div class="text-box-skeleton">
              <Skeleton
                height="15px"
                width="150px"
              />
              <Skeleton
                height="15px"
                width="120px"
              />
            </div>
          </div>
          <div class="skeleton-price">
            <Skeleton
              height="25px"
              width="70px"
            />
          </div>
        </div>
      </div>
      <message
        v-if="productsList != null && productsList.length == 0 && !reloadingProducts"
        name="warning"
        :data="data={data: $t('no_shipping_options'), type:'validation'}" />
      <!-- Skeleton -->
      <div v-if="reloadingProducts">
        <div class="toggle-card-box card p-40 relative"
          v-for="(product, index) in productsCompiledList"
          :key="`productSkeleton-${product.shipping_product_id}-${index}`">
          <div class="card-skeleton-layout">
            <Skeleton
              height="55px"
              width="62px"
              class="m-r-20"
            />
            <div class="text-box-skeleton">
              <Skeleton
                height="15px"
                width="150px"
              />
              <Skeleton
                height="15px"
                width="120px"
              />
            </div>
          </div>
          <div class="skeleton-price">
            <Skeleton
              height="25px"
              width="70px"
            />
          </div>
        </div>
      </div>
      <!-- Products -->
      <div v-if="!reloadingProducts">
        <ToggleCard
          v-for="(product, index) in productsCompiledList"
          :key="`product-${product.shipping_product_id}-${index}`"
          :product="product"
          :showPrices="showPrices"
          :pickupDate="pickupDate"
          :pickupLocationId="pickupLocationId"
          :editShipmentDroppointNo="editShipmentDroppointNo"
          :editPickupDriverNote="pickupDriverNote"
          :editPickupTimeUntil="pickupTimeUntil"
          :editPickupTimeFrom="pickupTimeFrom"
          :editPickupTimeZone="pickupTimeZone"
          :selectedServices="selectedServices"
          :customsData="customsData"
          :disable-book-button="disableBookButton"
          :enabledProducts="enabledProductsByServices"
          :senderHandlingType="senderHandlingType"
          :enabledInsuranceCategory="isInsuranceCategoryEnabled"
          :isOpened="(selectedProduct != null) && (selectedProduct.shipping_product_id == product.shipping_product_id)"
          @updateInsuranceCategory="updateInsuranceCategoryAndMakeCall"
          @triggerShipment="bookShipment"
          @selected="selectProduct" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import _ from 'lodash';
import ToggleList from '@/components/global/toggleList/index.vue';
import ToggleCard from '@/components/global/toggleCard/index.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import { Skeleton } from 'vue-loading-skeleton';
import countryList from "@/data/country";
import mixin from '@/mixins/mixins.js';
import {DateTime} from "luxon";
import date from "@/mixins/date";
import ButtonCalendar from "@/components/elements/inputs/buttonCalendar.vue";
import TextSelect from "@/components/elements/inputs/textSelect.vue";
import InputSelect from "@/components/elements/inputs/select.vue";
import Dropdown from "@/components/global/dropdown/index.vue";

export default {
  name: 'AdditionalServices',
  mixins: [mixin, date],
  components: {
    Dropdown,
    InputSelect,
    TextSelect,
    ButtonCalendar,
    Toggle,
    ToggleList,
    ToggleCard,
    Skeleton,
  },
  props: {
    senderHandlingType: {
      type: [String, Number],
      default: '',
    },
    pickupLocationId: {
      type: [String, Number],
      default: '',
    },
    editShipmentDroppointNo: {
      type: [String, Number],
      default: '',
    },
    showColliContent: {
      type: Array,
      default: [],
    },
    shipperAsSenderID: {
      type: [String, Number],
      default: '',
    },
    pickupDate: {
      type: [String, Date],
      default: '',
    },
    shippingDate: {
      type: [String, Date],
      default: '',
    },
    dataForProducts: {
      type: Object,
      default() {
        return null;
      },
    },
    observableObject: {
      type: Object,
      default() {
        return null;
      },
    },
    companyFromListener: {
      type: String,
      default: '',
    },
    companyToListener: {
      type: String,
      default: '',
    },
    shipToPrivateResident: {
      type: Boolean,
      default: false,
    },
    fromReferenceListener: {
      type: Object,
      default: () => {
        return {
          ref: '',
          required: false,
        };
      },
    },
    toReferenceListener: {
      type: Object,
      default: () => {
        return {
          ref: '',
          required: false,
        };
      },
    },
    incotermServiceIds: {
      type: Array,
      default() {
        return [];
      },
    },
    externallyInjectedServiceIds: {
      type: Array,
      default() {
        return [];
      },
    },
    apiFeeIds: {
      type: Array,
      default() {
        return [];
      },
    },
    apiActiveServices: {
      type: Object,
      default() {
        return null;
      },
    },
    selectedProductId: {
      type: [Number, String],
      default: '',
    },
    additionalServicesFieldsData: {
      type: Object,
      default() {
        return null;
      },
    },
    pickupTimeFrom: {
      type: [String],
      default: '',
    },
    pickupTimeUntil: {
      type: [String],
      default: '',
    },
    customsData: {
      type: [Object],
      required: false
    },
    pickupTimeZone: {
      type: [String],
      default: '',
    },
    pickupDriverNote: {
      type: [String],
      default: '',
    },
    isDroppoint: {
      type: Boolean,
      default: false
    },
    disableBookButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
      localSelectedProductId: null,
      insuranceCategory: null,
      showPrices: false,
      showProductType: '1', //show all products
      reloadingProducts: false,
      update: 0,
      activeFilter: 'cheapest',
      servicesList: null,
      servicesAllowed: [],
      enabledServicesByProduct: [],
      // cachedEnabledServices: [],
      productsList: null,
      productsAllowed: [],
      enabledProductsByServices: [],
      // FILTER DATA
      byPrice: '',
      // DATA
      selectedProduct: null, // cannot be used in bookShipment method, cause its not up to date, cause it is updated on select product event and some actions are done after that event
      selectedServices: [],
      // Additional field data
      additionalFieldData: {},
 //     isDroppoint: false,
      externalApiLoaded: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_user',
    ]),
    isCustomShippingDate() {
      let inTheList = true;
      this.getFirstFiveAvailableShippingDates.forEach(date => {
          if(date.toFormat('yyyy-MM-dd') === this.shippingDate) {
            inTheList = false
          }
      });
      return inTheList
    },
    isInsuranceCategoryEnabled() {
      if(this.servicesList == null) return false;
      let result = false;
      this.servicesList.forEach((serviceGroup) => {
        if(parseInt(serviceGroup.id) === 9) {
          Object.keys(serviceGroup.services).forEach((key) => {
            if(this.selectedServices.indexOf(serviceGroup.services[key].id) > -1){
              result = true;
            }
          })
        }
      })
      return result;
    },
    productsCompiledList(){
      // IF NO SERVICES CHOOSEN
      if(this.productsList === null) return null;
      // IF SERVICES CHOOSEN

      //If all products should be shown without prices, then sort them by delivery time
      if (this.showProductType == 1 && !this.showPrices) {
        this.activeFilter = 'fastest';
      }

      //If only one cheapest product should be shown, then active filter should be set to cheapest
      if (this.showProductType == 2) {
        this.activeFilter = 'cheapest';
      }

      //If only one fastest product should be shown, then active filter should be set to fastest
      if (this.showProductType == 3) {
        this.activeFilter = 'fastest';
      }

      // FILTER LIST
      let productsListFiltered = this.productsList;

      let productsValidPrice = [];
      let productsValidNoPrice = [];
      let productsServiceErrorPrice = [];
      let productsServiceErrorNoPrice = [];
      let productsWithErrorPrice = [];
      let productsWithErrorNoPrice = [];

      if(!this.productsList || !Array.isArray(this.productsList)) return [];

      this.productsList.forEach((product) => {
        if(this.enabledProductsByServices.indexOf(product.shipping_product_id) == -1 && this.enabledProductsByServices.length > 0){
          if(product.prices_data.total_price == 0){
            productsServiceErrorNoPrice.push(product);
          } else {
            productsServiceErrorPrice.push(product);
          }
        } else {
          if(product.prices_data.total_price == 0){
            if('error' in product.prices_data) {
              productsWithErrorNoPrice.push(product);
            } else if(product.api_errors.length > 0) {
              productsWithErrorNoPrice.push(product);
            } else {
              productsValidNoPrice.push(product)
            }
          } else {
            if('error' in product.prices_data) {
              productsWithErrorPrice.push(product);
            } else if(product.api_errors.length > 0) {
              productsWithErrorPrice.push(product);
            } else {
              productsValidPrice.push(product)
            }
          }
        }
      })

      if(this.activeFilter !== '') {
        // Return by filter
        if(this.activeFilter == 'fastest'){
          productsListFiltered = [
            ...this.sortByTime([
              ...this.sortByPrice(productsValidPrice),
              ...this.sortByPrice(productsValidNoPrice)
            ]),
            ...this.sortByTime([
              ...this.sortByPrice(productsServiceErrorPrice),
              ...this.sortByPrice(productsServiceErrorNoPrice)
            ]),
            ...this.sortByTime([
              ...this.sortByPrice(productsWithErrorPrice),
              ...this.sortByPrice(productsWithErrorNoPrice)
            ]),
          ];
        }
        if(this.activeFilter == 'cheapest'){
          productsListFiltered = [
            ...this.sortByPrice(productsValidPrice),
            ...this.sortByPrice(productsValidNoPrice),
            ...this.sortByPrice(productsServiceErrorPrice),
            ...this.sortByPrice(productsWithErrorPrice),
            ...this.sortByPrice(productsServiceErrorNoPrice),
            ...this.sortByPrice(productsWithErrorNoPrice),
          ];
        }
      }

      //Show one cheapest or fastest product only
      if (['3', '2'].includes(this.showProductType.toString())) {
        return [productsListFiltered[0]];
      }

      // Return without filter
      return productsListFiltered;
    },
    servicesCompiledList() {
      if(this.selectedProduct == null) {
        // IF PRODUCT NOT SELECTED && SERVICE SELECTED
        if(this.selectedServices.length > 0){
          this.enabledServicesByProduct = [];
          if(this.productsList != null){
            this.productsList.forEach((product) => {
              if(this.enabledProductsByServices.indexOf(product.shipping_product_id) > -1){
                product.allowed_services.forEach((id) => {
                  if(this.enabledServicesByProduct.indexOf(parseInt(id)) < 0) {
                    this.enabledServicesByProduct.push(parseInt(id));
                  }
                });
              }
            });
            return this.servicesAllowed;
          }
          return this.enabledServicesByProduct;
        } else {
          return this.servicesAllowed;
        }

      } else {
        // IF PRODUCT SELECTED
        return this.enabledServicesByProduct;
      }
    },
  },
  created() {
    if(this.dataForProducts === null) return;

  },
   mounted() {
     // Trigger initial rate request once the component becomes visible (e.g., after subaccount selection)
     if (this.validateDataForProducts('mounted')) {
       this.makeCall();
     }
  },
  methods: {
    setShippingDate(date) {

      if (date instanceof DateTime) {
        date = date.toFormat('yyyy-MM-dd')
      }
      this.$emit('set-shipping-date', date)
    },
    findSelectedServiceIdByCategory(category) {
      let returnServiceId = null;
      //Dynamically find insurance selected service ID
      this.servicesList.forEach((serviceGroup) => {
        Object.keys(serviceGroup.services).forEach((key) => {
          const serviceId = serviceGroup.services[key].id;
          if (serviceGroup.id == category && this.selectedServices.includes(serviceId)) {
            returnServiceId = serviceId.toString();
          }
        });
      });

      return returnServiceId
    },
    sortByPrice(arr) {
      return arr.sort((a, b) =>
        (a.prices_data.total_price > b.prices_data.total_price) ||
        (a.prices_data.total_price == b.prices_data.total_price) ? 1 : -1);
    },
    sortByTime(arr) {
      return arr.sort((a, b) =>
          ((a.estimated_time.compare > b.estimated_time.compare) ||
          (a.estimated_time.compare == b.estimated_time.compare) ? 1 : -1));
    },
    updateInsuranceCategory(val) {
      const insuranceServiceId = this.findSelectedServiceIdByCategory(9); //Insurance category

      if (!insuranceServiceId) {
        console.log('Insurance service Id not found');
        return;
      }

      this.insuranceCategory = val;
      this.additionalFieldData[insuranceServiceId] = {...this.additionalFieldData[insuranceServiceId], category: val};
    },
    updateInsuranceCategoryAndMakeCall(val) {
      this.updateInsuranceCategory(val);
      this.makeCall()
    },
    extraFieldAdd(field) {
      this.additionalFieldData = {...this.additionalFieldData, ...field};
    },
    bookShipment(val) {
      this.$emit('bookShipment', {
        droppoint_no: val.droppoint_no,
        product: val.product, //this.selectedProduct was used, cannot be used here cause its not up to date, it is updated on select product event and some actions are done after that event
        notification: val,
        services: [...this.selectedServices, ...this.externallyInjectedServiceIds],
        additionalFieldData: this.additionalFieldData,
        pickup_driver_note: val.pickup_driver_note,
        pickup_time_from: val.pickup_time_from,
        pickup_time_until: val.pickup_time_until,
        pickup_time_zone: val.pickup_time_zone,
        pickup_action: val.pickup_action,
        pickup_product_id: val.pickup_product_id,
        pickup_ship_date: val.pickup_ship_date
      });
    },
    validateDataForProducts(paramLog) {
      console.log('VALIDATE: ', paramLog)
      if(this.dataForProducts.subaccountId == '') return false;
      if(this.dataForProducts.shippingDate == '') return false;
      if(!this.isInfoValid('from')) return false;
      if(!this.isInfoValid('to')) return false;
      if(this.dataForProducts.activeGoodsType == '') return false;
      if(!this.isColliValid(this.dataForProducts.colli)) return false;
      //If pickup address exist check it
      if (this.dataForProducts.useDiffPickupAddress) {
        if(!this.isInfoValid('pickup')) return false;
      }

      return true;
    },
    isInfoValid(type) {
      if(this.postCodeRequired(type)
        && (this.dataForProducts[`${type}Address`].post_code === ''
          || this.dataForProducts[`${type}Address`].post_code === undefined
          || this.dataForProducts[`${type}Address`].post_code === null)
      ) {
        return false;
      }
      if(this.dataForProducts[`${type}Address`].country_id === ''
        || this.dataForProducts[`${type}Address`].country_id === undefined
        || this.dataForProducts[`${type}Address`].country_id === null) {
        return false;
      }

      return true;
    },
    postCodeRequired(type) {
      if( this.dataForProducts[`${type}Address`] && this.dataForProducts[`${type}Address`].country_id !== '' && this.dataForProducts[`${type}Address`] !== undefined){
        return !!Number(countryList.filter((opt) => opt.id === this.dataForProducts[`${type}Address`].country_id.toString())[0].has_postcode)
      }
      return true;
    },
    isColliValid(colliArray) {
      let result = true;
      if (colliArray.length < 1) {
        result = false;
      }

      colliArray.forEach((colli, index) => {
        const groupIndex = parseInt(colli.group.replace(/^\D+/g, ''));
        // if (this.showColliContent[groupIndex]) {
        //   colli.content_json.forEach((cnt) => {
        //     if (!cnt.unit_weight || !cnt.unit_value || !cnt.unit_value_currency) result = false;
        //   })
        // } else {
        //   if (colli.weight == '' ||
        //     colli.weight == '0' ||
        //     colli.weight == 0 ||
        //     colli.weight == undefined ||
        //     colli.weight == 'undefined' ||
        //     colli.weight == null) {
        //     result = false;
        //   }
        // }

        if (colli.weight == '' ||
          colli.weight == '0' ||
          colli.weight == 0 ||
          colli.weight == undefined ||
          colli.weight == 'undefined' ||
          colli.weight == null) {
          result = false;
        }

        if(colli.isTemperature == true){
          if(colli.min_temp == '' || colli.max_temp == ''){
            result = false;
          }
        };
        if(colli.isDgToggleActive == true){
          colli.services_json.forEach((service) => {
            if (service.fee_wrapper_id === null || service.fee_wrapper_id === ""
              || service.dangerous_goods_id == null || service.dangerous_goods_id === ""
              || service.brutto_weight == null || service.brutto_weight === ""
            ) {
              result = false;
            }
          });

        };
        if(colli.hasOwnProperty('cubic_meter')){
          if(
            (colli.cubic_meter == '' && colli.load_meter == '') &&
            (colli.length == '' || colli.width == '' || colli.height == '')){
            result = false;
          }
        } else {
          if(colli.length == '' || colli.width == '' || colli.height == '') {
            result = false;
          }
        }
      });

      return result;
    },
    makeCall: _.debounce(function(event) {
      this.reloadingProducts = true;
      this.update++;
      this.$store.dispatch('GET_AVAILABLE_PRODUCTS', {
        broker_details: this.dataForProducts.broker_details,
        sender_id: this.shipperAsSenderID,
        sender_handling_type: this.dataForProducts.senderHandlingType,
        subaccount_id: this.dataForProducts.subaccountId,
        ship_date: this.dataForProducts.shippingDate,
        sender: {
          company_name: this.dataForProducts.fromData.company,
          post_code: this.dataForProducts.fromAddress.post_code,
          country_code: this.getCountry(this.dataForProducts.fromAddress.country_id, 'alpha2'),
          address_1: this.dataForProducts.fromAddress.address_1,
          address_2: this.dataForProducts.fromAddress.address_2,
          city: this.dataForProducts.fromAddress.city,
          state: this.dataForProducts.fromAddress.state,
        },
        pickup: {
          company_name: this.dataForProducts.pickupData.company,
          post_code: this.dataForProducts.pickupAddress.post_code,
          country_code: this.dataForProducts.pickupAddress.country_id ? this.getCountry(this.dataForProducts.pickupAddress.country_id, 'alpha2') : '',
          address_1: this.dataForProducts.pickupAddress.address_1,
          address_2: this.dataForProducts.pickupAddress.address_2,
          city: this.dataForProducts.pickupAddress.city,
          state: this.dataForProducts.pickupAddress.state,
        },
        customer: {
          //If is ship to business resident and there is no company name, rate request should pass, so we need to use fake company for BE logic
          company_name: (!this.shipToPrivateResident && !this.dataForProducts.toData.company) ? 'Fake company' : this.dataForProducts.toData.company,
          post_code: this.dataForProducts.toAddress.post_code,
          country_code: this.getCountry(this.dataForProducts.toAddress.country_id, 'alpha2'),
          address_1: this.dataForProducts.toAddress.address_1,
          address_2: this.dataForProducts.toAddress.address_2,
          city: this.dataForProducts.toAddress.city,
          state: this.dataForProducts.toAddress.state,
        },
        should_send_customs_file: this.dataForProducts.showCustoms ? '1' : '0',
        customs_document_type: this.customsData ? this.customsData.documentType : null,
        goods_type: this.dataForProducts.activeGoodsType,
        is_droppoint: this.isDroppoint,
        colli: this.dataForProducts.colli,
        content: this.dataForProducts.content,
        use_content_on_shipment_level: this.dataForProducts.useContentOnShipmentLevel,
        goods_incoterm: this.dataForProducts.customsData.goods_incoterm,
        duty_paid_by: this.dataForProducts.customsData.duty_paid_by,
        duty_payer_account_no: this.dataForProducts.customsData.duty_payer_account_no,
        freight_paid_by: this.dataForProducts.customsData.freight_paid_by,
        freight_payer_account_no: this.dataForProducts.customsData.freight_payer_account_no,
        freight_payer_id: this.dataForProducts.customsData.freight_payer_id,
        fee_wrapper_ids_json: [...this.selectedServices, ...this.incotermServiceIds, ...this.externallyInjectedServiceIds].filter((value, index, array) => array.indexOf(value) === index), //get unique
        active_services_json: this.additionalFieldData,
        goods_types: this.dataForProducts.activeGoodsTypes
      }).then((res) => {
        //this.enabledProductsByServices = [];
        //this.enabledServicesByProduct = [];
        this.servicesList = res ? res.services : [];
        this.productsList = res ? res.products : [];
        this.servicesAllowed = res ? res.service_ids : [];
        this.productsAllowed = res ? res.product_ids : [];
        this.showPrices      = res ? res.show_prices : false;
        this.showProductType = res && res.show_product_type !== undefined ? res.show_product_type.toString() : '1';
        this.$emit('available-incoterms', res ? res.available_incoterms : []);

        // Check if selected product is in products list
        let isProductInList = false;
        if(this.productsList && Array.isArray(this.productsList)) {
          this.productsList.forEach((product) => {
            if(product.shipping_product_id == this.localSelectedProductId) isProductInList = true;
          })
        }
        //console.log(this.localSelectedProductId)
        if(this.localSelectedProductId != 0 && this.productsList != null && isProductInList){
          this.selectedProduct = this.productsList.filter((product) => Number(product.shipping_product_id) == this.localSelectedProductId)[0];
          this.enabledServicesByProduct = this.selectedProduct.allowed_services;
        }
        this.reloadingProducts = false;
        // console.log('after rate call')
        // console.log(this.apiFeeIds)
        // console.log(this.externalApiLoaded)
        if(this.apiFeeIds && this.apiFeeIds.length > 0){ //What is puprose of? !this.externalApiLoaded
          this.externalApiLoaded = true;
          // CHECK FOR ENABLED PRODUCTS BY SELECTED SERVICES THAT ARE PASSED FORM API
          this.productsList.forEach((product) => {
            // console.log(product.shipping_product_id)
            // console.log(product.allowed_services)
            // console.log(product.selectedServices)
            product.allowed_services.forEach((id) => {
              if(this.isProductAllowed(product.shipping_product_id)) {
                this.enabledProductsByServices.push(parseInt(product.shipping_product_id));
              }
            });
          });
        }
        //console.log('-------------')
      });
    }, 500),
    selectProduct(val) {
      this.update++;
      // If product was selected and this is close product card change
      // AND changed product is equal to selected then enter condition
      if((this.selectedProduct != null) && (val.product.id == this.selectedProduct.id)) {
        this.selectedProduct = null;
        this.localSelectedProductId = null;
        this.enabledServicesByProduct = [];
        return;
      }
      this.enabledServicesByProduct = val.allowedServices;
      this.selectedProduct = val.product;
      this.localSelectedProductId = null;
      this.insuranceCategory = null; //Reset insurance category on product select
    },
    isProductAllowed(productId) {
      var result = true;
      // console.log('isProductAllowed')
      // console.log(this.servicesList)
      this.servicesList.forEach((serviceGroup) => {
        Object.keys(serviceGroup.services).forEach((key) => {
          // console.log('isProductAllowed loop')
          // console.log(this.selectedServices)
          // console.log(serviceGroup.services[key].id)
          if(this.selectedServices.includes(serviceGroup.services[key].id)){
            //console.log(serviceGroup.services[key].allowed_products.includes(productId))
            if(!serviceGroup.services[key].allowed_products.includes(productId)){
              result = false;
              return;
            }
          }
        })
        return;
      })
      //console.log('---------')
      return result;
    },
    servicesUpdate(val) {
      console.log('SERVICES - servicesUpdate')
      this.reloadingProducts = true;
      this.selectedServices = val.services;
      this.additionalFieldData = val.additionalFieldData;
      // FILTER
      this.enabledProductsByServices = [];
      if(this.selectedServices.length > 0){
        this.productsList.forEach((product) => {
          product.allowed_services.forEach((id) => {
            if(this.isProductAllowed(product.shipping_product_id)) {
              this.enabledProductsByServices.push(parseInt(product.shipping_product_id));
            }
          });
        });
      } else {
        this.enabledProductsByServices = this.productsAllowed.map((id) => parseInt(id));
      }
      this.makeCall();
    },
  },
  watch: {
    additionalServicesFieldsData: {
      handler() {
        if(this.additionalServicesFieldsData != null) {
          this.additionalFieldData = this.additionalServicesFieldsData;
        }
      },
      deep: true,
    },
    apiActiveServices: {
      handler(newVal, oldVal){
        if(this.apiActiveServices != null){
          Object.keys(this.apiActiveServices).forEach((key, index) => {
            this.additionalFieldData[this.apiActiveServices[key].fee_wrapper_id] = {
              currency: this.apiActiveServices[key].currency,
              name: this.apiActiveServices[key].name,
              service_category: this.apiActiveServices[key].service_category,
              value: this.apiActiveServices[key].value,
            }
          });
        }
      },
      deep: true
    },
    apiFeeIds: {
      handler(newVal, oldVal){
        if(this.apiFeeIds && this.apiFeeIds.length > 0){
          this.selectedServices = this.apiFeeIds;
        }
      },
      deep: true
    },
    additionalFieldData: {
      handler(newVal, oldVal){
        if(this.servicesList == null) return false;
        this.servicesList.forEach((serviceGroup) => {
          Object.keys(serviceGroup.services).forEach((key) => {
            let serviceCategoryId = serviceGroup.id;
            let ServiceId = serviceGroup.services[key].id;
            if(this.additionalFieldData.hasOwnProperty(ServiceId)){
              if(_.isEqual(oldVal[ServiceId], newVal[ServiceId]) == false && this.validateDataForProducts('additionalFieldData')){

                //If service category is insurance and insurance category received from child component exist, update additionalFieldData
                if (serviceCategoryId == 9 && this.insuranceCategory) {
                  this.updateInsuranceCategory(this.insuranceCategory)
                }

                this.makeCall();
              }
            }
          })
        })
      },
      deep: true
    },
    observableObject: {
      handler(newVal, oldVal){
        // console.log(_.isEqual(oldVal, newVal))
        // console.log(newVal.colli[0].pallet_exchange[0], oldVal.colli[0].pallet_exchange[0]);
        if(_.isEqual(oldVal, newVal) == false && this.validateDataForProducts('observableObject')){
          this.makeCall();
        }
      },
      deep: true
    },
    fromReferenceListener: {
      handler(newVal, oldVal){
        if(!newVal.required) return;
        if(newVal.val == oldVal.val) return;
        if(this.validateDataForProducts('fromReferenceListener')){
          console.log('fromReferenceListener')
          this.makeCall();
        }
      },
      deep: true
    },
    toReferenceListener: {
      handler(newVal, oldVal){
        if(!newVal.required) return;
        if(newVal.val == oldVal.val) return;
        if(this.validateDataForProducts('toReferenceListener')){
          console.log('toReferenceListener')
          this.makeCall();
        }
      },
      deep: true
    },
    companyFromListener: {
      handler(newVal, oldVal){
        if(newVal == '' && oldVal == '') return;
        if(newVal.length >= 1  && oldVal.length >= 1) return;
        if(newVal == '' && oldVal.length >= 1 || newVal.length >= 1 && oldVal == ''){
          if(this.validateDataForProducts('companyFromListener')){
            this.makeCall();
          }
        }
      },
    },
    companyToListener: {
      handler(newVal, oldVal){
        if(newVal == '' && oldVal == '') return;
        if(newVal.length >= 1  && oldVal.length >= 1) return;
        if(newVal == '' && oldVal.length >= 1 || newVal.length >= 1 && oldVal == ''){
          if(this.validateDataForProducts('companyToListener')){
            this.makeCall();
          }
        }
      },
    },
    shipToPrivateResident: {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        if (this.validateDataForProducts('shipToPrivateResident')) {
          this.makeCall();
        }
      },
    },
    externallyInjectedServiceIds: {
      handler(){
        if(this.validateDataForProducts('externallyInjectedServiceIds')){
          this.makeCall();
        }
      },
    },
    incotermServiceIds: {
      handler() {
        this.makeCall();
      },
      deep: true,
    },
    'customsData.freight_payer_id': {
      handler(){
        if(this.validateDataForProducts('customsData.freight_payer_id')){
          this.makeCall();
        }
      },
    },
    'customsData.freight_paid_by': {
      handler(){
        if(this.validateDataForProducts('customsData.freight_paid_by')){
          this.makeCall();
        }
      },
    },
    'customsData.documentType': {
      handler(){
        if(this.validateDataForProducts('customsData.documentType')){
          this.makeCall();
        }
      },
    },
    isDroppoint: {
      handler(newVal, oldVal){
        if(_.isEqual(oldVal, newVal) === false && this.validateDataForProducts('observableObject')){
          this.makeCall();
        }
      },
      deep: true
    },
    editShipmentDroppointNo: {
      handler(newVal, oldVal){
        this.isDroppoint = !!newVal;
      },
      deep: true
    },
    selectedProductId: {
      handler(newVal, oldVal){
        this.localSelectedProductId = newVal;
      },
      deep: true
    }
  },
}
</script>
<style>
  .ship-date-block {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 75px;
  }
  .ship-date-block-month, .ship-date-block-addition {
    font-size: 10px;
  }
  .ship-date-block-date {
    font-size: 20px;
  }
</style>
